const publications = [
  {
    type: "Publication",
    title: "Growing an Agile Culture from Value Seeds",
    venue: "IEEE Computer Society — August 2009",
    description:
      "Explores how values can be powerful forces in a small company, growing personalized practices from agile value seeds to instill a creative force for change and adaptation.",
  },
  {
    type: "Publication",
    title: "The Pairing Session as the Atomic Unit of Work",
    venue: "IEEE Computer Society — July 2006",
    description:
      "Describes using the pairing session as the fundamental unit of work for organizing, planning, estimating, tracking, and pair programming on an Extreme Programming team.",
  },
  {
    type: "Patent",
    title: "Method and Apparatus for Software Delivery and Management",
    venue: "US Patent 8,216,071 — Issued March 2002",
    description:
      "A method and apparatus for software delivery and management including electronic catalog-based game distribution with preview and purchase functionality.",
  },
];

export function Publications() {
  return (
    <section id="publications" className="section section-alt">
      <div className="section-inner">
        <h2 className="section-title">Publications & Patents</h2>
        <div className="pub-list">
          {publications.map((pub) => (
            <div className="pub-card" key={pub.title}>
              <div className="pub-type">{pub.type}</div>
              <div className="pub-title">{pub.title}</div>
              <div className="pub-venue">{pub.venue}</div>
              <p className="pub-description">{pub.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
